import React from "react";

const StrukturTwo = () => {
  return (
    <div className="my-4 lg:my-6 mx-6 lg:mx-10 border border-[#144470] rounded-lg p-4">
      <div className="my-0 md:my-4  text-xl md:text-4xl text-[#144470] text-center font-semibold">
        Struktur <span className="text-[#cfa84d]">Organisasi</span>
      </div>
      <img src="/images/bagan2.png" alt="" className="mt-4 md:mt-2 mb-2 md:mb-4" />
    </div>
  );
};

export default StrukturTwo;
